import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { AUTH_API_URL } from "../config";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      await axios.post(`${AUTH_API_URL}/forgot-password`, { email });
      setIsSuccess(true);
      setMessage(t('forgot.success'));
    } catch (error) {
      setIsSuccess(false);
      setMessage(error.response?.data?.error || t('forgot.error'));
    }
  };

  return (
    <div className="auth-container">
      <h2>{t('forgot.title')}</h2>
      <p>{t('forgot.description')}</p>
      {!isSuccess ? (
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder={t('forgot.email_placeholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">{t('forgot.send_link')}</button>
        </form>
      ) : (
        <div className="success-message">
          <p>{message}</p>
          <p>{t('forgot.check_email')}</p>
        </div>
      )}
      {!isSuccess && message && <p className="error-message">{message}</p>}
      <Link to="/login" className="auth-link">{t('forgot.back_login')}</Link>
    </div>
  );
};

export default ForgotPassword; 
